import { useMutation, useQuery } from "@tanstack/react-query";

const API_BASE = import.meta.env.VITE_API_URL ?? "/api";

interface JoinWaitlistPayload {
  email: string;
}

export function useWaitlistCount() {
  return useQuery({
    queryKey: ["waitlist", "count"],
    queryFn: async () => {
      const response = await fetch(`${API_BASE}/waitlist/count`);
      if (!response.ok) return { count: 0 };
      return response.json() as Promise<{ count: number }>;
    },
    staleTime: 60_000,
  });
}

export function useJoinWaitlist() {
  return useMutation({
    mutationFn: async (payload: JoinWaitlistPayload) => {
      const response = await fetch(`${API_BASE}/waitlist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ error: "Unknown error" }));
        throw new Error(error.error ?? "Erreur");
      }

      return response.json() as Promise<{ status: string; message: string }>;
    },
  });
}
